import React from 'react';

const CardExpress = () => (
  <svg
    width="43"
    height="23"
    viewBox="0 0 43 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 1.53585C0 0.687622 0.77363 0 1.71848 0H41.2722C42.2213 0 42.9907 0.688344 42.9907 1.53585V21.4642C42.9907 22.3124 42.217 23 41.2722 23H1.71848C0.769388 23 0 22.3117 0 21.4642V1.53585Z"
      fill="white"
    />
    <path
      d="M22.856 16.4964H15.991V5.49561H22.8561L22.856 16.4964Z"
      fill="#FF5F00"
    />
    <path
      d="M16.4263 10.9963C16.4263 8.76476 17.5981 6.77692 19.4228 5.49587C18.0416 4.52475 16.3332 3.99769 14.5743 4.00001C10.2413 4.00001 6.729 7.1323 6.729 10.9963C6.729 14.8603 10.2413 17.9925 14.5743 17.9925C16.3333 17.9949 18.0417 17.4678 19.4229 16.4967C17.5983 15.2159 16.4263 13.2279 16.4263 10.9963Z"
      fill="#EB001B"
    />
    <path
      d="M32.1176 10.9963C32.1176 14.8603 28.6053 17.9925 24.2724 17.9925C22.5132 17.9948 20.8046 17.4678 19.4231 16.4967C21.2483 15.2156 22.4201 13.2279 22.4201 10.9963C22.4201 8.76465 21.2483 6.77692 19.4231 5.49587C20.8046 4.52478 22.5131 3.99773 24.2722 4.00001C28.6052 4.00001 32.1175 7.1323 32.1175 10.9963"
      fill="#F79E1B"
    />
  </svg>
);

export default CardExpress;
